/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Mark_Paid_ReferenceInputs */

const vi_order_mark_paid_reference = /** @type {(inputs: Order_Mark_Paid_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh dấu thủ công`)
};

/**

* @param {Order_Mark_Paid_ReferenceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_mark_paid_reference = /** @type {((inputs?: Order_Mark_Paid_ReferenceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Mark_Paid_ReferenceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_mark_paid_reference(inputs)
});